<template>
  <div class="content">
    <div class="detail-drawer" v-loading="loading">
      <div class="drawer-title" :style="{'line-height': scheduleForm.scheduleName.length > 35 ? '' : '53px'}">
        <div class="drawer-title-icon">
          <i
            class="el-icon-close"
            @click="handleCloseDrawer"
            style="cursor: pointer"
          ></i>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <div>
              计划单:&nbsp;{{ scheduleForm.scheduleName }} &nbsp;
              <span style="color: rgba(0, 0, 0, 0.45)">{{
                scheduleForm.scheduleNo
              }}</span>
              <el-button
                v-if="scheduleForm.scheduleStatus === 2"
                size="mini"
                type="danger"
                :loading="retractLoading"
                @click="handleRetract"
              >撤回</el-button>
            </div>
          </div>
          <div class="drawer-operate">
            <el-button
              type="text"
              @click="$emit('edit', scheduleForm)"
              v-permission="'schedule:edit'"
              v-if="
                scheduleForm.scheduleStatus !== -1 &&
                scheduleForm.scheduleStatus !== 5 &&
                scheduleForm.scheduleStatus !== 11
              "
            >
              <i class="el-icon-cc-edit-square"></i>
            </el-button>
          </div>
        </div>
      </div>
      <el-tabs
        :tab-position="tabPosition"
        v-model="activeName"
        style="height: 100%"
        class="drawer-tabs"
        @tab-click="handleTabClick"
      >
        <el-tab-pane name="detail">
          <span slot="label"> <i class="el-icon-view"></i> 详情 </span>
          <div class="drawer-tabs-content">
            <div class="title-text">基本信息</div>
            <el-form label-width="110px" label-position="left">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="订单名称">
                    {{ scheduleForm.adOrder.orderName || '-' }}</el-form-item
                  >
                </el-col>
                <el-col :span="12">
                  <el-form-item label="订单编号">{{
                    scheduleForm.adOrder.orderNo || '-'
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="计划类型">{{
                    scheduleForm.planType
                  }}</el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="程序化来源">{{
                    scheduleForm.scheduleSourceText
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="程序化类型">{{
                    scheduleForm.supportMode
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="销售方式">{{
                    scheduleForm.saleType
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="投放渠道">{{
                    scheduleForm.channelId
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="结算方式">{{
                    scheduleForm.payment
                  }}</el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="结算监测">
                    {{
                      $consts.SettlementTypeText[scheduleForm.settlementType]
                    }}
                    <span>{{
                      scheduleForm.settlementProvider !== '0'
                        ? scheduleForm.settlementProvider
                        : ''
                    }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="优先级">{{
                    scheduleForm.seq
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="投放速度">{{
                    scheduleForm.trafficSpeed
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col v-if="scheduleForm.pvRateName" :span="12">
                  <el-form-item label="TA浓度">{{
                    scheduleForm.pvRateName
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="KPI考核">{{
                    scheduleForm.kpiLabel
                    }}</el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.uaTaLabel">
                <el-col :span="24">
                  <el-form-item label="N+UV指标">{{
                    scheduleForm.uaTaLabel
                    }}</el-form-item>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 10px" v-if="uvRateTable.header.length > 1">
                <el-col>
                  <el-form-item  label="曝光频次规则">
                    <Table
                      :props="uvRateTable.props"
                      ref="uvRateStrTable"
                      :data="uvRateTable.data"
                      :header="uvRateTable.header"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="uvRateStrTable.header.length > 1">
                <el-col>
                  <el-form-item  label="曝光频次占比">
                    <Table
                      :props="uvRateStrTable.props"
                      ref="uvRateStrTable"
                      :data="uvRateStrTable.data"
                      :header="uvRateStrTable.header"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.taCondition">
                <el-col :span="24">
                  <el-form-item label="TA考核">{{ scheduleForm.taCondition }}</el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.extendParam">
                <el-col :span="24">
                  <el-form-item label="扩展参数">
                  </el-form-item>
                </el-col>
                <Table
                  :props="paramsTable.props"
                  ref="paramsTable"
                  :data="paramsTable.data"
                  :header="paramsTable.header"
                />
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="IES服务">
                    <span :style="{ color: scheduleForm.iesSwitch === 1 ? '#19bf44' : '#666' }">{{ ['关闭', '开启'][scheduleForm.iesSwitch || 0] }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="title-text">投放设置</div>
              <el-row>
                <el-col>
                  <el-form-item label="广告位">{{
                    scheduleForm.spaceName
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="投放时间">
                    <div
                      v-for="(item, index) in scheduleForm.timeList"
                      :key="'t' + index"
                    >
                      <el-row>
                        <el-col :span="8">
                          {{ $moment(item.beginTime).format('YYYY-MM-DD') }} ~
                          {{ $moment(item.endTime).format('YYYY-MM-DD') }}
                        </el-col>
                        <el-col :span="6">
                          {{ $moment(item.beginTime).format('HH:mm:ss') }} ~
                          {{ $moment(item.endTime).format('HH:mm:ss') }}
                        </el-col>
                      </el-row>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="投放总量">
                    <template v-if="scheduleForm.trafficType === 1">
                      不限量
                    </template>
                    <template v-else-if="scheduleForm.trafficType === 2">
                      总共投 {{ scheduleForm.totalTraffic / 1000 }} CPM
                    </template>
                    <template v-else>
                      <span class="inline-text">分天投 {{ scheduleForm.totalTraffic / 1000 }} CPM</span>
                      <span class="inline-text">排期量 {{ scheduleForm.payDailyTraffic }} CPM</span>
                      <span class="inline-text">赠送量 {{ scheduleForm.freeDailyTraffic }} CPM</span>
                      <span class="inline-text">补量 {{ scheduleForm.addedDailyTraffic }} CPM</span>
                      <div class="form-table">
                        <div class="form-table-box">
                          <div class="form-table-box-th"></div>
                          <div class="form-table-box-td">投放总量</div>
                          <div class="form-table-box-td">排期量</div>
                          <div class="form-table-box-td">赠送量</div>
                          <div class="form-table-box-td">补量</div>
                        </div>
                        <div
                          class="form-table-box"
                          v-for="(item,
                          index) in scheduleForm.adScheduleRegionDailys"
                          :key="'d' + index"
                        >
                          <div
                            :class="
                              $moment(item.daily).day() === 0 ||
                              $moment(item.daily).day() === 6
                                ? 'form-table-box-th-light'
                                : 'form-table-box-th'
                            "
                          >
                            {{ $moment(item.daily).format('MM-DD') }}
                          </div>
                          <div class="form-table-box-td" :title="item.totalTraffic">{{ item.totalTraffic || '-' }}</div>
                          <div class="form-table-box-td" :title="scheduleForm.payDailyTraffics[item.daily]">{{ scheduleForm.payDailyTraffics[item.daily] || '-' }}</div>
                          <div class="form-table-box-td" :title="scheduleForm.freeDailyTraffics[item.daily]">{{ scheduleForm.freeDailyTraffics[item.daily] || '-' }}</div>
                          <div class="form-table-box-td" :title="scheduleForm.addedDailyTraffics[item.daily]">{{ scheduleForm.addedDailyTraffics[item.daily] || '-' }}</div>
                        </div>
                      </div>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.trafficType === 2">
                <el-col :span="6">
                  <el-form-item label="排期总量">{{ scheduleForm.payTotalTraffic / 1000 }} CPM</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="赠送总量">{{ scheduleForm.freeTotalTraffic / 1000 }} CPM</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="补量总量">{{ scheduleForm.addedTotalTraffic / 1000 }} CPM</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="频次控制">
                    <template> {{ $consts.frequencyText[scheduleForm.frequency]}}</template>
                    <template v-if="scheduleForm.frequency > 1">
                      {{ scheduleForm.trafficDaily }}次
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="双周期频控">
                    <template v-if="scheduleForm.subFrequency === 1">否</template>
                    <template v-else> {{ $consts.frequencyText[scheduleForm.subFrequency] || '否' }}</template>
                    <template v-if="scheduleForm.subFrequency > 1">
                      {{ scheduleForm.subTrafficDaily }}次
                    </template>
                  </el-form-item>
                </el-col>
                 <el-col :span="20">
                   <el-form-item label="关联频控">
                      <span>{{ ['否', '有序', '无序'][scheduleForm.unionSequence] }}</span>
                      <template v-if="scheduleForm.unionSequence !== 0">
                        <span style="padding-left:20px">频控 {{ $consts.frequencyText[scheduleForm.frequency] }}</span>
                        <span style="padding-left:5px">{{scheduleForm.unionFreq}} 次</span>
                        <template v-if="scheduleForm.subFrequency !== 1">
                          <span style="padding-left:20px">双周期 {{ $consts.frequencyText[scheduleForm.subFrequency] }}</span>
                          <span style="padding-left:5px">{{scheduleForm.subUnionFreq}} 次</span>
                        </template>
                      </template>
                   </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="selectTable.data.length >0">
                <el-col>
                   <el-form-item>
                  <Table
                    :props="selectTable.props"
                    ref="selectTable"
                    :data="selectTable.data"
                    :header="selectTable.header"
                  />
                   </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="家庭去重">
                    {{ scheduleForm.homeDeWeight }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="自动补量">{{
                    scheduleForm.autoFilling
                  }}</el-form-item>
                </el-col>
              </el-row>
               <el-row>
                <el-col :span="12">
                  <el-form-item label="售卖价格">
                    {{ parseFloat(scheduleForm.sellingPrice || 0) }} 元/{{ scheduleForm.billType === 3 ? 'CPD' : 'CPM' }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col v-if="scheduleForm.planType==='程序化采买'" :span="12">
                  <el-form-item label="放量溢出比">
                    {{scheduleForm.receivePct}} %
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="曝光溢出比">
                    <span v-if="scheduleForm.exposurePct === 0">默认</span>
                    <template v-else>
                      <span>{{ scheduleForm.exposurePct }} %</span>
                      <span v-if="scheduleForm.checkExposurePct > 0">(考核值{{ scheduleForm.checkExposurePct }}%，额外溢出{{ scheduleForm.addExposurePct }}%)</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.exposureDirectly !== undefined">
                <el-col>
                  <el-form-item label="计划强植入">{{ ['启用', '不启用'][scheduleForm.exposureDirectly] }}</el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.ctr > 0">
                <el-col :span="12">
                  <el-form-item label="CTR权重">{{ scheduleForm.ctr }} ‰</el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.dealId">
                <el-col :span="12">
                  <el-form-item label="DealID">
                    {{ scheduleForm.dealId }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="title-text">定向</div>
                <DirectionDetail :model="{ ...scheduleForm }" />
              </el-row>
              <el-row v-if="scheduleForm.recId">
                <el-col :span="12">
                  <el-form-item label="推荐流">
                    {{ scheduleForm.recName }}
                    <span style="color:#999"> ({{ scheduleForm.recId }})</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="scheduleForm.erpSubOrderModel">
                <div class="title-text">ERP订单</div>
                <ErpOrderDetail :model="scheduleForm.erpSubOrderModel" :spaceOptions="spaceList" :showTitle="false" />
              </el-row>
              <el-row v-if="scheduleForm.salesSuborderModel">
                <div class="title-text">关联销售子订单</div>
                <SalesSubOrderDetail :model="scheduleForm.salesSuborderModel" :billType="scheduleForm.billType" />
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="media">
          <span slot="label"> <i class="el-icon-document"></i> 创意 </span>
          <div class="drawer-tabs-content" v-if="scheduleForm.scheduleSource !== 0">
            <ProgrammaticDetail :scheduleForm="scheduleForm" :creativeModel="creativeModel" />
          </div>
          <div v-else>
            <template v-if="mediaList.length > 1">
              <el-collapse v-model="activeCollapse">
                <el-collapse-item
                  v-for="(item, index) in mediaList"
                  :key="index"
                  :title="`素材${index + 1}`"
                  :name="index + ''"
                >
                <CreativeDetail :mediaModel="item" @reload-content="$emit('reload-content')" />
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-else>
              <CreativeDetail :mediaModel="mediaList[0]" @reload-content="$emit('reload-content')" />
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane name="dataCharts">
          <span slot="label"> <i class="el-icon-cc-linechart"></i> 数据 </span>
          <template v-if="activeChartName !== 'frequency'">
            <el-row>
              <el-col>
                <div class="cc-operation-area">
                  <el-row>
                    <el-col style="text-align: end">
                      <template v-if="activeChartName === 'orderBasic'">
                        <el-select
                          v-model="showType"
                          placeholder="请选择"
                          style="margin-right: 16px"
                          size="small"
                        >
                          <el-option
                            v-for="item in seeTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>

                      <el-date-picker
                        class="form-time-picker"
                        v-model="searchTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        size="small"
                      ></el-date-picker>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </template>
          <div style="display: flex; flex-direction: row" v-if="showCharts">
            <div class="tab-left">
              <el-tabs
                v-model="activeChartName"
                @tab-click="handleChartTabClick"
                class="cc-tabs"
              >
                <el-tab-pane label="基础数据" name="orderBasic">
                  <OrderBasic
                    v-if="
                      scheduleChartData.orderId &&
                      activeChartName === 'orderBasic'
                    "
                    :scheduleChartData="scheduleChartData"
                  ></OrderBasic>
                </el-tab-pane>
                <el-tab-pane label="地域数据" name="area">
                  <AreaData
                    v-if="
                      scheduleChartData.orderId && activeChartName === 'area'
                    "
                    :scheduleChartData="scheduleChartData"
                  ></AreaData>
                </el-tab-pane>
                <el-tab-pane label="受众人群" name="audience">
                  <Audience
                    v-if="
                      scheduleChartData.orderId &&
                      activeChartName === 'audience'
                    "
                    :scheduleChartData="scheduleChartData"
                  ></Audience>
                </el-tab-pane>
                <el-tab-pane label="频次达到" name="frequency">
                  <Frequency
                    v-if="
                      scheduleChartData.orderId &&
                      activeChartName === 'frequency'
                    "
                    :scheduleChartData="scheduleChartData"
                  ></Frequency>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="log">
          <span slot="label"> <i class="el-icon-date"></i> 日志 </span>
          <div class="drawer-tabs-content">
            <div class="title-text">操作日志</div>
            <Table
              :props="logTable.props"
              :header="logTable.header"
              :data="logData"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import OrderBasic from '@/views/dataReport/charts/OrderBasicChart'
import AreaData from '@/views/dataReport/charts/AreaDataChart'
import Audience from '@/views/dataReport/charts/AudienceDataChart'
import Frequency from '@/views/dataReport/charts/FrequencyDataChart'
import CreativeDetail from '../creative/components/CreativeDetail'
import ProgrammaticDetail from '../creative/components/ProgrammaticDetail'
import ErpOrderDetail from '@/components/schedule/ErpOrderDetail.vue'
import SalesSubOrderDetail from '@/components/schedule/SalesSubOrderDetail.vue'
import DirectionDetail from '@/components/scheduleDirection/DirectionDetail.vue'
import { computed } from 'vue'

export default {
  components: {
    OrderBasic,
    AreaData,
    Audience,
    Frequency,
    CreativeDetail,
    ProgrammaticDetail,
    ErpOrderDetail,
    SalesSubOrderDetail,
    DirectionDetail
  },
  props: {
    mode: {
      type: String,
      default: 'read'
    },
    scheduleForm: {
      type: Object,
      default: () => {}
    },
    tabActiveName: {
      type: String,
      default: 'detail'
    },
    spaceList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      retractLoading: false,
      activeName: this.tabActiveName,
      tabPosition: 'left',
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      activeChartName: 'orderBasic',
      showType: 0,
      seeTypeOptions: [
        {
          value: 0,
          label: '分天展示'
        },
        {
          value: 1,
          label: '分小时展示'
        }
      ],
      creativeModel: {},
      searchTime: this.scheduleForm.adOrder
        ? [
          this.scheduleForm.adOrder.contractBeginDate || new Date(),
          new Date()
        ]
        : [new Date(), new Date()],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      mediaList: [],
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'light'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '操作者',
            align: 'left',
            prop: 'operator',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.userType) {
                return params.userType === 1 ? '管理后台' : params.operator
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作类型',
            align: 'left',
            prop: 'operateType',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.operateType || params.operateType === 0) {
                return this.$consts.operateTypeText[params.operateType]
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作内容',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': false,
            render: (h, { row }) => {
              return (
                <el-tooltip effect="light" content={row.description} placement="top">
                  <div slot="content" class="table-tooltip">{row.description}</div>
                  <span style="white-space: nowrap;">{row.description}</span>
                </el-tooltip>
              )
            }
          }
        ],
        data: []
      },
      logData: [],
      selectTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'unionSeq',
            label: '顺序'
          },
          {
            prop: 'scheduleNo',
            label: '计划单号',
            'min-width': '160'
          },
          {
            prop: 'scheduleName',
            label: '计划名称',
            'min-width': '200',
            'show-overflow-tooltip': true
          },
          {
            prop: 'spaceName',
            label: '广告位',
            'min-width': '160',
            'show-overflow-tooltip': true
          },
          {
            prop: 'frequency',
            label: '频次控制',
            show: true,
            'min-width': '140',
            formatter: params => {
              return this.$consts.frequencyText[params.frequency] + params.trafficDaily + '次'
            }
          },
          {
            prop: 'subFrequency',
            label: '双周期频控',
            show: this.scheduleForm && this.scheduleForm.subFrequency !== 1,
            'min-width': '140',
            formatter: params => {
              return params.subFrequency !== 1
                ? this.$consts.frequencyText[params.subFrequency] + params.subTrafficDaily + '次'
                : this.$consts.frequencyText[params.subFrequency]
            }
          },
          {
            prop: 'scheduleStatus',
            label: '状态',
            'min-width': '80',
            formatter: params => {
              return this.$consts.shceduleStatusText[params.scheduleStatus]
            }
          },
          {
            prop: 'orderNo',
            label: '订单号',
            'min-width': '160',
            'show-overflow-tooltip': true
          },
          {
            prop: 'orderName',
            label: '订单名称',
            'min-width': '200',
            'show-overflow-tooltip': true
          }
        ],
        data: this.scheduleForm.scheduleUnionList || []
      },
      uvRateTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [],
        data: []
      },
      uvRateStrTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'unionSeq',
            label: '频次规则'
          }
        ],
        data: []
      },
      paramsTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'key',
            label: 'key',
            width: '250'
          },
          {
            prop: 'value',
            label: 'value'
          }
        ],
        data: this.scheduleForm.extendParam || []
      },
      activeCollapse: '0',
      eventTempList: [],
    }
  },
  watch: {
    scheduleForm: {
      handler() {
        this.activeName = this.tabActiveName
        this.selectTable.data = this.scheduleForm.scheduleUnionList || []
        this.paramsTable.data = this.scheduleForm.extendParam || []
        this.logData = this.scheduleForm.logData || []
        if (this.scheduleForm.uvRateStr && this.scheduleForm.uvRateStr.length) {
          let uvRateStrHeader = [{
            label: '频次',
            align: 'center',
            prop: 'title'
          }]
          let uvRateStrData = [{
            title: '占比'
          }]
          this.scheduleForm.uvRateStr.forEach((item, index) => {
            uvRateStrHeader.push({
              label: item.trafficDaily + '',
              align: 'center',
              prop: 'value' + item.trafficDaily
            })
            uvRateStrData[0]['value' + item.trafficDaily] = item.uvRate + '%'
          })
          this.uvRateStrTable = {
            props: {
              border: true,
              'tooltip-effect': 'dark'
            },
            header: uvRateStrHeader,
            data: uvRateStrData
          }
        } else {
          this.uvRateStrTable.header = []
          this.uvRateStrTable.data = []
        }
        if (this.scheduleForm.uvRateList && this.scheduleForm.uvRateList.length) {
          let uvRateHeader = [{
            label: '频次',
            align: 'center',
            prop: 'title'
          }]
          let uvRateData = [{
            title: '占比'
          }]
          this.scheduleForm.uvRateList.forEach((item, index) => {
            uvRateHeader.push({
              label: item.uvMatch === 0 ? `${item.maxFrequency}` : `${item.minFrequency} ~ ${item.maxFrequency}`,
              align: 'center',
              prop: 'value' + index
            })
            uvRateData[0]['value' + index] = item.uvPercentage + '%'
          })
          this.uvRateTable = {
            props: {
              border: true,
              'tooltip-effect': 'dark'
            },
            header: uvRateHeader,
            data: uvRateData
          }
        } else {
          this.uvRateTable.header = []
          this.uvRateTable.data = []
        }
      },
      deep: true
    }
  },
  computed: {
    scheduleChartData() {
      let obj = {}
      if (
        this.scheduleForm.adOrder.orderId &&
        this.activeName === 'dataCharts'
      ) {
        obj.orderId = this.scheduleForm.adOrder.orderId
        obj.scheduleId = this.scheduleForm.scheduleId
        obj.showType = this.showType
        obj.time = this.searchTime
      }
      return obj
    },
    showCharts() {
      let show = false
      if (this.activeName === 'dataCharts') {
        show = true
      } else {
        show = false
      }
      return show
    }
  },
  provide() {
    return {
      eventTempList: computed(() => this.eventTempList)
    }
  },
  async created() {
    this.eventTempList = await this.$service.getTargetTemp({})
  },
  methods: {
    // 撤回审核
    handleRetract() {
      const params = {
        operateType: 8,
        ids: [this.scheduleForm.scheduleId]
      }
      this.retractLoading = true
      this.$service.operate(params).then((data) => {
        this.retractLoading = false
        if (data.code === 0) {
          this.$emit('reload-content')
          this.$message.success('撤回成功')
        }
      })
        .catch(() => {
          this.retractLoading = false
        })
    },
    handleCloseDrawer() {
      this.$emit('closeDrawer', true)
    },
    handleChartTabClick() {},
    handleTabClick() {
      if (this.activeName === 'media') {
        if (this.scheduleForm.scheduleSource !== 0) {
          this.getProgrammaticDetail()
          return
        }
        this.$service
          .scheduleMedias(this.scheduleForm.scheduleId)
          .then((data) => {
            if (data.length > 0) {
              this.mediaList = data.map(item => {
                return {
                  ...item,
                  activeEventTab: 'keyEventList'
                }
              })
            }
          })
      }
    },
    handleMediaRead(val) {
      this.$router.push({
        name: 'materialCreative',
        params: {
          mediaId: val.mediaId,
          scheduleId: this.scheduleForm.scheduleId
        }
      })
    },
    getAdAgentAccountList() {
      const params = {
        flag: 2
      }
      this.$service.getAdAgentAccountList(params).then(data => {
        this.relateAgentAccountList = data
      }).catch(() => {
      })
    },
    getProgrammaticDetail() {
      this.$service.getProgrammaticDetail(this.scheduleForm.scheduleId).then(res => {
        this.creativeModel = {
          ...res,
          ...res.programmedScheduleMedia
        }
      })
    }
  }
}
</script>
<style lang="stylus">
:focus {
  outline: 0;
}
.table-tooltip {
  min-height: 16px;
  max-width: 800px;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
<style lang="stylus" scoped>
>>>.el-table__empty-block {
  margin-left -1px
  border-right 1px solid #EBEEF5
}
.content {
  display: flex;
  flex-direction: column;
}

.detail-drawer {
  height: inherit;
}

.drawer-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 53px;
  // line-height: 53px;
}

.drawer-title-icon {
  width: 56px;
  text-align: center;
  height: inherit;
  background: rgba(10, 33, 64, 0.831372549019608);
  color: #fff;
  height: 53px;
  line-height: 53px;
}

.drawer-title-header {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 56px);
}

.drawer-title-text {
  height: inherit;
  padding: 0px 16px;
  font-size: 14px;
  .el-button {
    margin-left: 20px;
    background-color: #d9001b;
  }
}

.drawer-tabs-content {
  margin: 0 16px;
}

.drawer-operate {
  display: flex;
  align-items: center;
  width: calc(100% - 630px);
  justify-content: flex-end;
  padding-right: 20px;
}

.drawer-tabs> >>>.el-tabs__header {
  margin: 0;
  padding: 0;
  width: 55px;
  border-bottom: none;
}

.drawer-tabs> >>>.el-tabs__content {
  border-top: 1px solid #f0f2f5;
  border-left: 1px solid #f0f2f5;
  height: calc(100vh - 60px);
  overflow: auto;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar {
  display: none;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item {
  padding: 0 !important;
  height 53px
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active {
  background-color: #ff8b00;
  color: #fff;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover {
  color: rgba(0, 0, 0, 0.65);
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item span {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56px;
  height 53px
  line-height: 2;
  font-weight: bold;
}

.drawer-tabs>>>.tab-left {
  width: 100%;
  display: flex;
  height: 100%;
}

.cc-tabs {
  width: 100%;
}

.cc-tabs>>>.el-tabs__nav-wrap:after {
  content: none !important;
}

.cc-tabs {
  >>>.el-tabs__nav {
    width: 100%;
  }

  >>>.el-tabs__item {
    line-height: 53px;
    width: auto !important;
    padding: 0 20px;
  }

  >>>.el-tabs__active-bar {
    width: 56px !important;
  }
}

.cc-operation-area {
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  height: 53px;
  line-height: 53px;
  padding: 0 16px;
}

.el-form-item {
  margin-bottom: 0px;
}

.form-table::after {
  clear: both;
  content: '';
  display: block;
  height: 0;
}

.form-table-box {
  float: left;
  border: 1px solid #f2f2f2;
  margin-left: -1px;
  margin-bottom: 5px;
}

.form-table-box-th, .form-table-box-th-light, .form-table-box-td {
  width: 60px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form-table-box-td {
  border-top: 1px solid #f2f2f2;
}

.form-table-box-th-light {
  background-color: #feefe3;
}

.detail-media {
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  border-bottom: 1px solid #f0f2f5;
}

.detail-media:last-child {
  border-bottom: none;
}

.media-img {
  width: 100%;
}

.media-img img {
  max-width: 100%;
  border-radius: 5px;
}

.media-info {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  justify-content: space-between;
}

.media-info-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-text {
  padding-right: 40px;
}
</style>
